module.exports = __webpack_public_path__ + "static/crossfader-m3.e455c71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/crossfader-m3.jpg
// module id = 459
// module chunks = 261706647590803